import { DateInput, FormItem, TextInput } from '@framework/form';
import { useTranslation } from '@framework/i18n';
import { DividerTitleElement, RowElement } from '@framework/ui';
import { ICitizenRegisterDto } from '../../../routes/login/schema/CitizenRegisterSchema';
import { HomeCountrySelect } from './HomeCountrySelect';

const TFormItem = FormItem as typeof FormItem<ICitizenRegisterDto>;

export interface IUserProfileFieldsFormProps {
  readonly?: boolean;
  hideExtraUEFields?: boolean;
}

export function UserProfileFieldsForm(props: IUserProfileFieldsFormProps) {
  const { hideExtraUEFields } = props;
  const { t } = useTranslation();

  return (
    <>
      <DividerTitleElement
        orientation="center"
        color="secondary"
        removeTopMargin
        title={
          <b>{t('user-registration-form.divider-title', 'Dati anagrafici')}</b>
        }
      />
      <RowElement>
        <TFormItem
          label={t('user-registration-form.profile.name', 'Nome')}
          name="nome"
          readonly={props.readonly}
        >
          <TextInput
            name="nome"
            placeholder={t('user-registration-form.profile.name', 'Nome')}
            readOnly={props.readonly}
          />
        </TFormItem>
        <TFormItem
          label={t('user-registration-form.profile.familyName', 'Cognome')}
          name="cognome"
          readonly={props.readonly}
        >
          <TextInput
            name="cognome"
            placeholder={t(
              'user-registration-form.profile.familyName',
              'Cognome',
            )}
            readOnly={props.readonly}
          />
        </TFormItem>
      </RowElement>
      {!hideExtraUEFields && (
        <>
          <RowElement>
            <TFormItem
              name="codiceFiscale"
              label={t(
                'user-registration-form.profile.fiscal-number',
                'Codice Fiscale',
              )}
            >
              <TextInput
                name="codiceFiscale"
                placeholder={t(
                  'user-registration-form.profile.fiscal-number',
                  'Codice Fiscale',
                )}
              />
            </TFormItem>

            <TFormItem
              name="dataNascita"
              label={t(
                'user-registration-form.profile.date-of-birth',
                'Data di Nascita',
              )}
            >
              <DateInput
                type="date"
                name="dataNascita"
                placeholder={t(
                  'user-registration-form.profile.date-of-birth',
                  'Data di Nascita',
                )}
              />
            </TFormItem>
          </RowElement>

          <RowElement>
            <TFormItem
              name="luogoNascita"
              label={t(
                'user-registration-form.profile.place-of-birth',
                'Luogo di Nascita',
              )}
            >
              <TextInput
                name="luogoNascita"
                placeholder={t(
                  'user-registration-form.profile.place-of-birth',
                  'Luogo di Nascita',
                )}
              />
            </TFormItem>
            <TFormItem
              name="provinciaNascita"
              label={t(
                'user-registration-form.profile.country-of-birth',
                'Provincia di Nascita',
              )}
            >
              <TextInput
                name="provinciaNascita"
                placeholder={t(
                  'user-registration-form.profile.country-of-birth',
                  'Provincia di Nascita',
                )}
              />
            </TFormItem>

            <TFormItem
              name="paeseProvenienza"
              label={t(
                'user-registration-form.profile.country',
                'Paese di provenienza',
              )}
            >
              <HomeCountrySelect name="paeseProvenienza" />
            </TFormItem>
          </RowElement>

          <TFormItem
            name="telefonoCellulare"
            label={t(
              'user-registration-form.profile.mobile-phone',
              'Telefono Cellulare',
            )}
          >
            <TextInput
              name="telefonoCellulare"
              placeholder={t(
                'user-registration-form.profile.mobile-phone',
                'Telefono Cellulare',
              )}
            />
          </TFormItem>
        </>
      )}
    </>
  );
}
